

// import aiAxiosInstance from "../../apiAxios/aiAxiosInstance";
import aiAxiosInstance from "../../apiAxios/axiosInstance";

// Start AI Call
// export const startAiCall = async (payload) => {
//     const response = await aiAxiosInstance.post(
//         "vendor/campaign",
//         payload
//     );

//     return response.data;
// };

export const startAiCall = async (payload) => {
    const response = await aiAxiosInstance.post(
        "/admin/demo-calling-clients",
        payload
    );

    return response.data;
};

// export const viewCallDetail = async (phone) => {
//     const response = await aiAxiosInstance.get(
//         `vendor/lead/${phone}`,
//     );

//     return response.data;
// };

export const viewCallDetail = async(phone) => {
  const response = await aiAxiosInstance.post("/admin/demo-single-call-history", {
    mobile: phone,
  });
  return response
};

// export const getAiCallHistory = async (payload) => {
//     const response = await aiAxiosInstance.get(
//         "vendor/results/22222222-2222-2222-2222-222222222222",
//         payload
//     );

//     return response.data;
// };

export const getAiCallHistory = async (payload) => {
    const response = await aiAxiosInstance.get(
        "/admin/demo-calling-client-get",
        payload
    );

    return response.data;
};